import { Background } from 'apps/shared/scripts/__generated__/graphql.generated';

export const DEFAULT_DESIGN = {
  color: '#979797',
  background: {
    attachment: 'scroll',
    color: '#ffffff',
    size: 'auto',
    src: '',
  } as Background,
  name: '',
  id: 'default-id-123',
};
